document.addEventListener('alpine:init', () => {
    Alpine.store('resultsData', {
        results: null,
        isSolved: false,
    });
});

document.addEventListener('htmx:afterSwap', (event) => {
    if (event.target.id === 'results') {
        Alpine.store('resultsData', {
            results: JSON.parse(document.getElementById('results-data').textContent),
            isSolved: JSON.parse(document.getElementById('is-solved').textContent),
        });
    }
});

document.addEventListener('alpine:init', () => {
    Alpine.data('results', () => ({
        section: {
            viewMode: 'loads',
            selectedLoadCase: '',
            selectedLoadType: 'load-case',
            selectedCase: '',
            showNodeLabels: true,
            showMemberLabels: true,
            showReactions: true,
            reactionsScale: 10,
            showAxialForces: true,
            axialForcesScale: 10,
            showShearForces: true,
            shearForcesScale: 10,
            showBendingMoments: true,
            bendingMomentsScale: 10,
            showDisplacements: true,
            displacementsScale: 20,
            feaResults: null,
            designResults: null,
            model: null,
        },

        purlin: {
            viewMode: 'loads',
            selectedLoadCase: '',
            selectedLoadType: 'load-case',
            selectedCase: '',
            showNodeLabels: true,
            showMemberLabels: true,
            showReactions: true,
            reactionsScale: 10,
            showAxialForces: true,
            axialForcesScale: 10,
            showShearForces: true,
            shearForcesScale: 10,
            showBendingMoments: true,
            bendingMomentsScale: 10,
            showDisplacements: true,
            displacementsScale: 20,
            feaResults: null,
            designResults: null,
            model: null,
        },

        loadCases: [],
        loadCombinations: [],
        combinationEnvelopes: [],

        getMaxSectionUsage( memberValues ) {
            if (this.section.selectedLoadType === 'combination-envelope') {
                return (memberValues.max_usage * 100).toFixed(2);
            } else if (memberValues.combinations && memberValues.combinations[this.section.selectedCase]) {
                return (memberValues.combinations[this.section.selectedCase].max_usage * 100).toFixed(2);
            } else {
                return 'N/A';
            }
        },

        getMaxPurlinUsage( memberValues ) {
            if (this.purlin.selectedLoadType === 'combination-envelope') {
                return (memberValues.max_usage * 100).toFixed(2);
            } else if (memberValues.combinations && memberValues.combinations[this.purlin.selectedCase]) {
                return (memberValues.combinations[this.purlin.selectedCase].max_usage * 100).toFixed(2);
            } else {
                return 'N/A';
            }
        },

        init() {
            this.$watch('$store.resultsData', (newVal) => {
                if (newVal) {
                    this.loading = false;
                }
                if (newVal && newVal.results) {
                    this.loadCases = newVal.results.load_cases || [];
                    this.loadCombinations = newVal.results.load_combinations || [];
                    this.combinationEnvelopes = newVal.results.combination_envelopes || [];

                    this.section.feaResults = newVal.results.section.fea_results || null;
                    this.section.designResults = newVal.results.section.design_results || null;
                    this.section.model = newVal.results.section.model || null;

                    this.section.viewMode = 'loads';
                    this.section.selectedLoadCase = this.loadCases[0].label;
                    this.section.selectedLoadType = 'load-case';
                    this.section.selectedCase = this.loadCases[0].label;

                    this.purlin.feaResults = newVal.results.purlin.fea_results || null;
                    this.purlin.designResults = newVal.results.purlin.design_results || null;
                    this.purlin.model = newVal.results.purlin.model || null;

                    this.purlin.viewMode = 'loads';
                    this.purlin.selectedLoadCase = this.loadCases[0].label;
                    this.purlin.selectedLoadType = 'load-case';
                    this.purlin.selectedCase = this.loadCases[0].label;

                    if (newVal.isSolved) {
                        setTimeout(() => {
                            this.sectionResultsViewer.loadModel(this.section.model);
                            this.sectionResultsViewer.drawLoads(this.section.model, this.section.selectedLoadCase);
                        }, 500);

                        if (this.roofType.includes('vaznice')) {
                            setTimeout(() => {
                                this.purlinResultsViewer.loadModel(this.purlin.model);
                                this.purlinResultsViewer.drawLoads(this.purlin.model, this.purlin.selectedLoadCase);
                            }, 500);
                        }
                    }
                }
            });

            const sectionCanvas = document.getElementById('roof-results-section-scene');
            this.sectionResultsViewer = new window.WBApp.utils.Viewer(sectionCanvas);
            this.sectionResultsViewer.config.updateSettings({
                showGrid: false,
                showOrigin: false,
                showNodeLabels: true,
                showMemberLabels: true,
            });

            const purlinCanvas = document.getElementById('roof-results-purlin-scene');
            this.purlinResultsViewer = new window.WBApp.utils.Viewer(purlinCanvas);
            this.purlinResultsViewer.config.updateSettings({
                showGrid: false,
                showOrigin: false,
                showNodeLabels: true,
                showMemberLabels: true,
            });


            this.$watch('section.selectedLoadType', () => {
                switch (this.section.selectedLoadType) {
                    case 'load-case':
                        this.section.selectedCase = this.loadCases[0].label;
                        break;
                    case 'load-combination':
                        this.section.selectedCase = this.loadCombinations[0].label;
                        break;
                    case 'combination-envelope':
                        this.section.selectedCase = this.combinationEnvelopes[0].label;
                        break;
                }
            });

            this.$watch('section.selectedLoadCase', (newVal) => {
                this.sectionResultsViewer.drawLoads(this.section.model, newVal);
            });

            this.$watch('section.selectedCase', (newVal) => {
                if (this.section.viewMode === 'results') {
                    if (this.section.selectedLoadType === 'combination-envelope') {
                        this.sectionResultsViewer.drawResults(this.section.feaResults, newVal, true);
                    } else {
                        this.sectionResultsViewer.drawResults(this.section.feaResults, newVal);
                    }
                }
            });

            this.$watch('section.viewMode', (newVal) => {
                if (newVal === 'loads') {
                    this.sectionResultsViewer.clearResults();
                    this.sectionResultsViewer.drawLoads(this.section.model, this.section.selectedLoadCase);
                }  else {
                    this.sectionResultsViewer.clearLoads();
                    this.sectionResultsViewer.drawResults(this.section.feaResults, this.section.selectedCase);
                }
            });

            this.$watch('section.showReactions', (newVal) => {
                this.sectionResultsViewer.config.updateSetting('showReactions', newVal);
            });

            this.$watch('section.showAxialForces', (newVal) => {
                this.sectionResultsViewer.config.updateSetting('showAxialForces', newVal);
            });

            this.$watch('section.showShearForces', (newVal) => {
                this.sectionResultsViewer.config.updateSetting('showShearForces', newVal);
            });

            this.$watch('section.showBendingMoments', (newVal) => {
                this.sectionResultsViewer.config.updateSetting('showBendingMoments', newVal);
            });

            this.$watch('section.showDisplacements', (newVal) => {
                this.sectionResultsViewer.config.updateSetting('showDeformations', newVal);
            });

            this.$watch('section.reactionsScale', (newVal) => {
                this.sectionResultsViewer.config.updateSetting('reactionsScaleFactor', newVal / 10);
            });

            this.$watch('section.axialForcesScale', (newVal) => {
                this.sectionResultsViewer.config.updateSetting('axialForcesScaleFactor', newVal / 10);
            });

            this.$watch('section.shearForcesScale', (newVal) => {
                this.sectionResultsViewer.config.updateSetting('shearForcesScaleFactor', newVal / 10);
            });

            this.$watch('section.bendingMomentsScale', (newVal) => {
                this.sectionResultsViewer.config.updateSetting('bendingMomentsScaleFactor', newVal / 10);
            });

            this.$watch('section.displacementsScale', (newVal) => {
                this.sectionResultsViewer.config.updateSetting('deformationsScaleFactor', newVal );
            });
            
            this.$watch('section.showNodeLabels', (newVal) => {
                this.sectionResultsViewer.config.updateSetting('showNodeLabels', newVal);
            });
            
            this.$watch('section.showMemberLabels', (newVal) => {
                this.sectionResultsViewer.config.updateSetting('showMemberLabels', newVal);
            });

            // PURLIN LOL

            this.$watch('purlin.selectedLoadType', () => {
                switch (this.purlin.selectedLoadType) {
                    case 'load-case':
                        this.purlin.selectedCase = this.loadCases[0].label;
                        break;
                    case 'load-combination':
                        this.purlin.selectedCase = this.loadCombinations[0].label;
                        break;
                    case 'combination-envelope':
                        this.purlin.selectedCase = this.combinationEnvelopes[0].label;
                        break;
                }
            });

            this.$watch('purlin.selectedLoadCase', (newVal) => {
                this.purlinResultsViewer.drawLoads(this.purlin.model, newVal);
            });

            this.$watch('purlin.selectedCase', (newVal) => {
                if (this.purlin.viewMode === 'results') {
                    if (this.purlin.selectedLoadType === 'combination-envelope') {
                        this.purlinResultsViewer.drawResults(this.purlin.feaResults, newVal, true);
                    } else {
                        this.purlinResultsViewer.drawResults(this.purlin.feaResults, newVal);
                    }
                }
            });

            this.$watch('purlin.viewMode', (newVal) => {
                if (newVal === 'loads') {
                    this.purlinResultsViewer.clearResults();
                    this.purlinResultsViewer.drawLoads(this.purlin.model, this.purlin.selectedLoadCase);
                }  else {
                    this.purlinResultsViewer.clearLoads();
                    this.purlinResultsViewer.drawResults(this.purlin.feaResults, this.purlin.selectedCase);
                }
            });

            this.$watch('purlin.showReactions', (newVal) => {
                this.purlinResultsViewer.config.updateSetting('showReactions', newVal);
            });

            this.$watch('purlin.showAxialForces', (newVal) => {
                this.purlinResultsViewer.config.updateSetting('showAxialForces', newVal);
            });

            this.$watch('purlin.showShearForces', (newVal) => {
                this.purlinResultsViewer.config.updateSetting('showShearForces', newVal);
            });

            this.$watch('purlin.showBendingMoments', (newVal) => {
                this.purlinResultsViewer.config.updateSetting('showBendingMoments', newVal);
            });

            this.$watch('purlin.showDisplacements', (newVal) => {
                this.purlinResultsViewer.config.updateSetting('showDeformations', newVal);
            });

            this.$watch('purlin.reactionsScale', (newVal) => {
                this.purlinResultsViewer.config.updateSetting('reactionsScaleFactor', newVal / 10);
            });

            this.$watch('purlin.axialForcesScale', (newVal) => {
                this.purlinResultsViewer.config.updateSetting('axialForcesScaleFactor', newVal / 10);
            });

            this.$watch('purlin.shearForcesScale', (newVal) => {
                this.purlinResultsViewer.config.updateSetting('shearForcesScaleFactor', newVal / 10);
            });

            this.$watch('purlin.bendingMomentsScale', (newVal) => {
                this.purlinResultsViewer.config.updateSetting('bendingMomentsScaleFactor', newVal / 10);
            });

            this.$watch('purlin.displacementsScale', (newVal) => {
                this.purlinResultsViewer.config.updateSetting('deformationsScaleFactor', newVal );
            });
            
            this.$watch('purlin.showNodeLabels', (newVal) => {
                this.purlinResultsViewer.config.updateSetting('showNodeLabels', newVal);
            });
            
            this.$watch('purlin.showMemberLabels', (newVal) => {
                this.purlinResultsViewer.config.updateSetting('showMemberLabels', newVal);
            });
        },
    }));
});